// extracted by mini-css-extract-plugin
export default {"list":"styles_list__LLfl8","item":"styles_item__b-2hh"};